import { useEffect, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, IconButton } from '@mui/material'
import { TableCellStyled, TableRowStyled, TableStyled } from 'components'
import { ItensConsolidacaoAdesao } from 'services/NGT/EffectiveConsolidation'

interface ICollapsibleTable {
  row: ItensConsolidacaoAdesao
  isGeneratePDF: boolean
}

export const CollapsibleTable = ({ row, isGeneratePDF }: ICollapsibleTable) => {
  const [open, setOpen] = useState(isGeneratePDF)

  useEffect(() => {
    if (isGeneratePDF) setOpen(true)
  }, [isGeneratePDF])

  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row?.itens.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
        <TableCellStyled align="left" minwidth="200px">
          {row?.totalizadores?.dsConsolidacao}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtMobilizacaoMensal}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtFornecedor}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtContratoPrincipal}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtSubContrato}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtTotalContratos}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtTotalContrapartes}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.qtContraparteNaoPreencheu}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.totalizadores?.peContrapartes}%
        </TableCellStyled>
      </TableRowStyled>

      {/*  INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && "none" }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled>

              <TableRowStyled>
                <TableCellStyled colSpan={1} />
                <TableCellStyled align="center">
                  Mobilizados no Mês
                </TableCellStyled>
                <TableCellStyled align="center">
                  Qtde de Fornecedor
                </TableCellStyled>
                <TableCellStyled align="center">
                  N° de Contratos
                </TableCellStyled>
                <TableCellStyled align="center">
                  N° de SubContratos
                </TableCellStyled>
                <TableCellStyled align="center">
                  Total (Contrato+Sub)
                </TableCellStyled>
                <TableCellStyled align="center">
                  Total de Contrapartes
                </TableCellStyled>
                <TableCellStyled align="center">
                  Contrapartes que Não Preencheram
                </TableCellStyled>
                <TableCellStyled align="center">
                  N° de Contrapartes(%)
                </TableCellStyled>
              </TableRowStyled>

              {row?.itens.map((collapseRow, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled
                    minwidth="220px"
                  >
                    {collapseRow?.dsConsolidacao}
                  </TableCellStyled>
                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtMobilizacaoMensal}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtFornecedor}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtContratoPrincipal}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtSubContrato}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtTotalContratos}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtTotalContrapartes}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.qtContraparteNaoPreencheu}
                  </TableCellStyled>

                  <TableCellStyled
                    align="center"
                  >
                    {collapseRow?.peContrapartes}%
                  </TableCellStyled>
                </TableRowStyled>
              ))}
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>

    </>
  )
}
